export default __webpack_public_path__ + "static/media/photo--lg--2.544eee74.jpg";